/* eslint-disable @typescript-eslint/naming-convention */
import { AddressByGoogle, DType, JsonReply, NextLocator, SelectOption } from '@grupo-constant/next-dtype/types';
import { LocaleString } from '../translate/localeString.model';
import { UserProfile } from '../../modules/admin/projects/projects.types';
import { CategoryNode } from '../../dialogs/category-tree-dialog/category-tree-dialog.component';

export interface MasterData extends DType {
    name?: string;
    index?: { column: string[]; unique: boolean }[];
    columnsForList?: string[];
    availableColumnsForList?: string[];
    columnsForExternalFilter?: string[];
    export?: string[];
    mask?: string;
    typology?: MasterTypology;
    validity?: MasterValidity;
    icon?: string;
    pseudoStatic?: boolean;
    noUpdate?: boolean;
    noInsert?: boolean;
    noDelete?: boolean;
    isManualOrder?: boolean;
    allowedUsers?: string[];
    allowedUsersProfile?: UserProfile[];
}

export interface RetrieveNewMasterInstaceBody {
    locator: NextLocator;
    typology: MasterTypology;
    validity: MasterValidity;
}

export interface RetrieveModifiedMasterInstaceBody {
    locator: NextLocator;
    validity: MasterValidity;
    uri: String;
}

export interface RetrieveNewMasterInstanceReply extends JsonReply {
    master: MasterData;
}

export interface RetrieveMasterCategoryTreeReply {
    status: number;
    tree: CategoryNode[];
    uri: string;
}

export interface FlushMasterCategoryTreeReply {
    status: number;
}

export interface RetrieveMasterDataAsSelectOptionReply extends JsonReply {
    selectOptions: SelectOption[];
}

export interface NextValueBody {
    sequenceName: string;
    chunkSize: number;
    typeIfNotExists?: string;
}

export interface NextValueReply {
    status: number;
    sequenceName: string;
    chunkSize: number;
    value: string[];
}

export interface DownloadMasterXSSFBody {
    uri: string;
    language?: string;
}

export interface UploadMasterXSSFBody {
    uri: string;
    file: string;
    excelType: string;
    forceUpload: boolean;
    async: boolean;
    keepOriginalData: boolean;
}

export interface UploadMasterXSSFResponse extends JsonReply {
    async?: boolean;
    forcedAsync?: boolean;
    created?: number;
    deleted?: number;
    updated?: number;
    processed?: number;
    errors?: number;
    warns?: number;
    file?: string;
}

export interface RetrieveLocationChangeRequest {
    oids: string[];
    includeMasterData: boolean;
    includeRequestData: boolean;
}

export interface LocationChangeRequestData {
    address: AddressByGoogle;
    masterLocationUri: string;
    oid: string;
    photo: string;
    reason: LocaleString;
    serviceId: string;
    taskId: string;
}
export interface RetrieveLocationChangeRequestReply {
    masterData?: any[];
    requestData?: LocationChangeRequestData[];
}

export interface MasterLocationCiCoBaseColumns {
    externalCode: string;
    name: string;
    checkInMode: GeolocationMode;
    checkInMaxMetersToLocation: number;
    checkOutMode: GeolocationMode;
    checkOutMaxMetersToLocation: number;
    address: AddressByGoogle
}

export enum GeolocationMode {
    geoposition = 'GEOPOSITION',
    silentGeoposition = 'SILENT GEOPOSITION', 
    simple = 'SIMPLE'
}

export enum MasterTypology {
    GENERAL = 'GENERAL',
    PLANNINGZONES = 'PLANNINGZONES',
    WORKPLACES = 'WORKPLACES',
    WORKDAYTYPE = 'WORKDAYTYPE',
    CATALOG = 'CATALOG',
    LOCATION = 'LOCATION',
    PROFESSIONAL_CATEGORY = 'PROFESSIONAL_CATEGORY',
    SYSTEM_CONFIG = 'SYSTEM_CONFIG'
}

export enum MasterValidity {
    FLAG = 'FLAG',
    PERIOD = 'PERIOD',
    DELETE = 'DELETE'
}
